import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';

import { USER_PROFILE_FORM_NAME } from 'Common/FormEnum';
import { UserProfileFieldEnum as Fields } from 'Common/FieldEnum';
import { InputField } from 'Common/SemanticWrapper';
import * as _ from 'lodash';
import { isValidEmail } from '../../../common/FormHelper';
import { TitledCard } from 'Components';

class UserProfileForm extends Component {
  render() {
    const { handleSubmit } = this.props;

    return (
      <Fragment>
        <Form onSubmit={handleSubmit}>
          <TitledCard title="">
            <Grid columns={3}>
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name={Fields.Username}
                    component={InputField}
                    type="text"
                    maxLength={30}
                    label={'Username'}
                    disabled={true}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={Fields.FirstName}
                    component={InputField}
                    type="text"
                    placeholder="First Name"
                    label={'First Name'}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={Fields.LastName}
                    component={InputField}
                    type="text"
                    placeholder="Last Name"
                    label={'Last Name'}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name={Fields.RoleDescription}
                    component={InputField}
                    type="text"
                    label="User Role"
                    disabled={true}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={Fields.Email}
                    component={InputField}
                    type="text"
                    placeholder="Email"
                    label={'Email'}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
          <TitledCard title="">
            <Grid columns={3}>
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name={Fields.OldPassword}
                    component={InputField}
                    type="password"
                    placeholder="Old Password"
                    label={'Old Password'}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name={Fields.NewPassword}
                    component={InputField}
                    type="password"
                    placeholder="New Password"
                    label={'New Password'}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={Fields.ConfirmPassword}
                    component={InputField}
                    type="password"
                    placeholder="Confirm Password"
                    label={'Confirm Password'}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values[Fields.FirstName]) {
    errors[Fields.FirstName] = 'First Name Required.';
  }

  if (!values[Fields.LastName]) {
    errors[Fields.LastName] = 'Last Name Required.';
  }

  if (
    values[Fields.Email] &&
    _.trim(values[Fields.Email]).length > 0 &&
    !isValidEmail(values[Fields.Email])
  ) {
    errors[Fields.Email] = 'Please enter a valid email address.';
  }

  if (
    values[Fields.OldPassword] ||
    values[Fields.NewPassword] ||
    values[Fields.ConfirmPassword]
  ) {
    if (!values[Fields.OldPassword]) {
      errors[Fields.OldPassword] = 'Old Password Required';
    }

    if (!values[Fields.NewPassword]) {
      errors[Fields.NewPassword] = 'New Password Required';
    }

    if (
      (values[Fields.NewPassword] && values[Fields.NewPassword].length < 6) ||
      (values[Fields.ConfirmPassword] &&
        values[Fields.ConfirmPassword].length < 6)
    ) {
      errors[Fields.ConfirmPassword] =
        'The password must be at least 6 characters.';
    }

    if (!values[Fields.ConfirmPassword]) {
      errors[Fields.ConfirmPassword] = 'Confirm Password Required';
    }

    if (
      values[Fields.ConfirmPassword] &&
      values[Fields.ConfirmPassword].length > 0 &&
      values[Fields.NewPassword] &&
      values[Fields.NewPassword].length > 0 &&
      values[Fields.NewPassword] !== values[Fields.ConfirmPassword]
    ) {
      errors[Fields.ConfirmPassword] = 'The new passwords must match';
    }

    if (
      values[Fields.OldPassword] &&
      values[Fields.OldPassword].length > 0 &&
      values[Fields.NewPassword] &&
      values[Fields.NewPassword].length > 0 &&
      values[Fields.NewPassword] === values[Fields.OldPassword]
    ) {
      errors[Fields.NewPassword] =
        'The new password cannot be the same as your old password';
    }
  }

  return errors;
};

export default reduxForm({
  validate,
  form: USER_PROFILE_FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(UserProfileForm);



// WEBPACK FOOTER //
// ./src/pages/userprofile/components/UserProfileForm.js